import 'dayjs/locale/en';
import { storage } from '../libs/firebase';
import * as Papa from 'papaparse';
import { ParsedCSVData } from '../interfaces/index.types';
import { getDownloadURL, ref, uploadString } from '../libs/storage-wrapper';
import { doc, getDoc, collection, db } from '../libs/firestore-wrapper';

const uploadImageToFirebaseStorage = async (file_base64: string, restaurant_id: string, food_id: string) => {
  try {
    const file_path = `food_detail/${restaurant_id}/${food_id}/food_image`;
    const storageRef = ref(storage, file_path);

    await uploadString(storageRef, file_base64, 'data_url');
    const downloadURL = await getDownloadURL(storageRef);

    return { download_url: downloadURL };
  } catch (error) {
    console.error('Error uploading image to Firebase Storage:', error);
    throw error;
  }
};

const formatPriceItem = (price: string | number) => {
  const parsedPrice = parseFloat(price.toString());

  if (isNaN(parsedPrice)) {
    return price;
  }

  const formattedPriceItem = parsedPrice.toLocaleString('ja-JP');

  return formattedPriceItem;
};

const parseCSV = (file: string): Promise<ParsedCSVData> => {
  return new Promise((resolve, reject) => {
    Papa.parse(file, {
      complete: (results) => {
        resolve(results.data as ParsedCSVData);
      },
      header: false,
      error: (error: any) => {
        reject(error);
      },
    });
  });
};

const fetchCSVFromStorage = async (stadiumId: string): Promise<ParsedCSVData> => {
  try {
    const storageRef = ref(storage, `stadium/${stadiumId}`);
    const url = await getDownloadURL(storageRef);

    const response = await fetch(url);
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }

    const data = await response.text();
    return await parseCSV(data);
  } catch (error) {
    return [];
  }
};

const fetchMultipleSeatsByTableNumbers = async (stadiumId: string | null, tableNumbers: string[], preOrder?: boolean): Promise<Map<string, any>> => {
  const seatCache = new Map<string, any>();

  if (!stadiumId || tableNumbers.length === 0) {
    return seatCache;
  }

  try {
    const DB_TABLE_STADIUM_MANAGE_SEATS = 'stadium_manage_seats';
    const seat_doc = preOrder ? 'data_2026' : 'data';

    const fetchPromises = tableNumbers.map(async (tableNumber) => {
      try {
        const seatsColRef = collection(db, DB_TABLE_STADIUM_MANAGE_SEATS, stadiumId, seat_doc);
        const docRef = doc(seatsColRef, tableNumber);
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          const data = docSnap.data();
          seatCache.set(docSnap.id, data);
        }
      } catch (err) {
        console.error(`Error fetching seat ${tableNumber}:`, err);
      }
    });

    await Promise.all(fetchPromises);
  } catch (error) {
    console.error('Error pre-fetching seat data:', error);
  }

  return seatCache;
};

export { uploadImageToFirebaseStorage, formatPriceItem, parseCSV, fetchCSVFromStorage, fetchMultipleSeatsByTableNumbers };
